export const getReactElement = () => {
    return document.getElementById('react-store-locator-app');
};
export const getElementAttribute = (attribute) => {
    const reactElement = getReactElement();
    if (!reactElement) {
        return '';
    }
    return reactElement.getAttribute(attribute) || '';
};
export const getPaths = () => {
    const reactElement = getReactElement();
    return JSON.parse(reactElement.dataset.paths || '{}');
};
